import {FACTIONS} from "../constants/factions";
import {POLICIES} from "../constants/policies";
import {PLAYER_BONUS_CONFIG, PLAYER_BONUS_TYPES} from "./playerBonus";
import {getBotBonusIntensity} from "./botBonusBehavior";

/**
 * Волна 36: боты «золото+» — с бонусом «большой» и выше (явные боты рейтинга
 * золотой, алмазной, рубиновой и божественной лиги и боты с таким же бонусом в
 * локальной партии и в лобби).
 *
 * Откуда. Прод-реплеи 27.10 (zml5bhz, z3lg8hs, w0gn7gj, f7l8kys): у ботов
 * золото+ 66% своих городов к концу партии без единого базового квартала (у
 * людей 46%), 9 казарм за партию против 4, из них 80% — в город без базового
 * квартала и 21% — третья и далее казарма города; кольцо центрального квартала,
 * где только и ставятся базовые кварталы, забито фермами и казармами уже в R1;
 * монеты копятся (запас после стройки R9–13 — 41 против 21 у людей). Рынок
 * политик боты не обновляют ни разу, а в 3–8 первых раундах сидят без политики:
 * на рынке нет того, что они готовы купить. Крайний случай — Вентори-рубин
 * «Сципион» (z3lg8hs): 17 казарм, 5 из 7 городов без базовых кварталов, ни одной
 * гильдии, Олигархия не появилась на рынке за всю партию.
 *
 * Порог считается от ЧИСЕЛ бонуса, как G волны 35 (W35_GARRISON_MIN_INTENSITY):
 * при правке баланса в configs/playerBonus он не уедет между уровнями. Состав
 * уровней держит тест utils/bots/evaluation/goldPlus.test.js.
 */
export const W36_GOLD_PLUS_MIN_INTENSITY = getBotBonusIntensity(
  PLAYER_BONUS_CONFIG[PLAYER_BONUS_TYPES.BIG]
);

/**
 * Топ-3 рекомендованных политик фракции для ботов золото+ — первые три в строке
 * «Политики:» developer_artifacts/factions_rules.md (рекомендации волны 24, они
 * же начало WAVE24_POLICY_PREFERENCES в decidePolicyStep) с решениями
 * владельца 27.10:
 *  - Вентори: OLIGARCHY THEOCRACY FANATICISM (Теократия — хорошая политика для
 *    фракции с +1 к доходу храмов);
 *  - гномам и элементалям Теократия тоже входит в топ-3 — только для ботов
 *    золото+ (вставлена второй, как у Вентори).
 * Политики этих списков бот золото+ ставит первыми в ранге ценности (признак
 * PT) и ради них обновляет рынок (признаки PR, PW, PX); вайтлист волны 30 на них
 * действует, кроме W36_GOLD_TOP_POLICIES_OUTSIDE_WHITELIST. У великанов данных
 * нет — списка нет, их цели считаются по ценности политик.
 */
export const W36_GOLD_TOP_POLICIES = {
  [FACTIONS.BEASTMEN]: [POLICIES.BARBARISM, POLICIES.ECOANARCHISM, POLICIES.HEGEMONISM],
  [FACTIONS.DEMONS]: [POLICIES.HEGEMONISM, POLICIES.ECOANARCHISM, POLICIES.AGRARIANISM],
  [FACTIONS.DWARVES]: [POLICIES.SERVARIANISM, POLICIES.THEOCRACY, POLICIES.HEGEMONISM],
  [FACTIONS.ELVES]: [POLICIES.HEGEMONISM, POLICIES.FANATICISM, POLICIES.BARBARISM],
  [FACTIONS.ENLIGHTENED]: [POLICIES.FANATICISM, POLICIES.OLIGARCHY, POLICIES.SERVARIANISM],
  [FACTIONS.HUMANS]: [POLICIES.FANATICISM, POLICIES.ECOANARCHISM, POLICIES.HEGEMONISM],
  [FACTIONS.INSECTOIDS]: [POLICIES.BARBARISM, POLICIES.TOTALITARIANISM, POLICIES.DESPOTISM],
  [FACTIONS.LEPRECHAUNS]: [POLICIES.AGRARIANISM, POLICIES.HEGEMONISM, POLICIES.FANATICISM],
  [FACTIONS.ORCS]: [POLICIES.TOTALITARIANISM, POLICIES.AGRARIANISM, POLICIES.HEGEMONISM],
  [FACTIONS.VENTORY]: [POLICIES.OLIGARCHY, POLICIES.THEOCRACY, POLICIES.FANATICISM],
  [FACTIONS.ELEMENTALS]: [POLICIES.OLIGARCHY, POLICIES.THEOCRACY, POLICIES.BARBARISM],
  [FACTIONS.RATMEN]: [POLICIES.ECOANARCHISM, POLICIES.FANATICISM, POLICIES.HEGEMONISM],
};

export const getW36GoldTopPolicies = (factionId) => W36_GOLD_TOP_POLICIES[factionId] || [];

/**
 * Какие политики топ-3 бот золото+ покупает и вне вайтлиста волны 30 — только
 * решения владельца 27.10 (Теократия Вентори и элементалей; гномам она есть и
 * в вайтлисте). Прочие политики топ-3 вне вайтлиста (Аграризм демонов,
 * лепреконов и орков, Тоталитаризм орков, Деспотизм инсектоидов, Олигархия
 * элементалей) остаются под вайтлистом, как в main: в факторном A/B волны 36
 * (8160 партий) покупка всего топ-3 стоила демонам −7.4 очка, лепреконам −8.8
 * (место хуже на 0.05 и 0.09), а боты с ней в целом −1.8 очка и место хуже на
 * 0.01 — вайтлист волны 30 и отсекал политики, с которыми бот не справляется.
 * Цели обновления рынка — те же: политику, которую бот не купит, он и не ищет
 */
export const W36_GOLD_TOP_POLICIES_OUTSIDE_WHITELIST = {
  [FACTIONS.VENTORY]: [POLICIES.THEOCRACY],
  [FACTIONS.DWARVES]: [POLICIES.THEOCRACY],
  [FACTIONS.ELEMENTALS]: [POLICIES.THEOCRACY],
};

export const getW36GoldTopPoliciesOutsideWhitelist = (factionId) => (
  W36_GOLD_TOP_POLICIES_OUTSIDE_WHITELIST[factionId] || []
);
